import { broadcastLaborOpenSessionChanged } from "@/lib/labor/laborOpenSessionSync";
import {
  clearLaborDepartureSnapshot,
  readLaborDepartureSnapshot,
  type LaborDepartureSnapshot,
} from "@/lib/labor/laborDepartureSnapshot";
import { clearLaborDevShellLock, readLaborDevShellLock } from "@/lib/labor/laborDevShellLock";
import { sendLaborDepartureEndBeacon } from "@/lib/labor/sendLaborDepartureEndBeacon";

/** Tab switches use `visibilitychange` only; `pagehide` with `persisted` is back/forward cache. */
export function shouldEndLaborOnPageHide(event: Pick<PageTransitionEvent, "persisted">): boolean {
  return !event.persisted;
}

export function laborDepartureTabOwnsSession(input: {
  sessionTabId: string;
  currentTabId: string;
}): boolean {
  return input.sessionTabId.trim() === input.currentTabId.trim();
}

export function resolveLaborPageDepartureAction(input: {
  currentTabId: string;
  snapshot: LaborDepartureSnapshot | null;
}): "end_server_session" | "clear_local_shell_only" | "noop" {
  const devShell = readLaborDevShellLock();
  if (devShell !== null && laborDepartureTabOwnsSession({ sessionTabId: devShell.tabId, currentTabId: input.currentTabId })) {
    if (input.snapshot !== null && laborDepartureTabOwnsSession({ sessionTabId: input.snapshot.tabId, currentTabId: input.currentTabId })) {
      return "end_server_session";
    }
    return "clear_local_shell_only";
  }
  if (
    input.snapshot !== null &&
    laborDepartureTabOwnsSession({ sessionTabId: input.snapshot.tabId, currentTabId: input.currentTabId })
  ) {
    return "end_server_session";
  }
  return "noop";
}

/** Runs synchronously during `pagehide` — no `await`. */
export function handleLaborPageDeparture(currentTabId: string): void {
  const snapshot = readLaborDepartureSnapshot();
  const action = resolveLaborPageDepartureAction({ currentTabId, snapshot });
  if (action === "noop") {
    return;
  }

  const devShell = readLaborDevShellLock();
  if (
    devShell !== null &&
    laborDepartureTabOwnsSession({ sessionTabId: devShell.tabId, currentTabId })
  ) {
    clearLaborDevShellLock();
  }

  if (action === "end_server_session" && snapshot !== null) {
    sendLaborDepartureEndBeacon(snapshot);
    clearLaborDepartureSnapshot();
    broadcastLaborOpenSessionChanged();
  }
}
